import { createElement } from "react";
/**
 * WordPress Dependencies
 */
import { useEffect, useState } from '@wordpress/element';

/**
 * External Depdnencies
 */
import classnames from 'classnames';
import { css } from 'emotion';

/**
 * Internal Dependencies
 */
import { useBlockTheme, useMessages } from '../../hooks';
import { HTMLParser } from '..';
const DefaultThankYouScreen = () => {
  const theme = useBlockTheme(undefined);
  const [isActive, setIsActive] = useState(false);
  const messages = useMessages();
  useEffect(() => {
    setIsActive(true);
  }, []);
  return createElement("div", {
    className: classnames('renderer-components-default-thankyou-screen', {
      active: isActive
    }, css`
					color: ${theme.questionsColor};
					font-family: ${theme.questionsLabelFont};
				`)
  }, createElement("div", {
    className: "qf-thankyou-screen-block__content-wrapper"
  }, createElement(HTMLParser, {
    value: messages['block.defaultThankYouScreen.label']
  })));
};
export default DefaultThankYouScreen;
//# sourceMappingURL=index.js.map